import React from "react";
// import user from "../../assets/img/icons/user_3.svg";
// import book from "../../assets/img/icons/book.svg";
import { useTabs } from "../../hooks/lib/useTabs";
import { Link } from "react-router-dom";
import { IAcademicsMppDetailsBannerData } from "../../exports/interfaces";

const GraduateIntroBanner = ({
  academicsMppDetailsBanner,
}: {
  academicsMppDetailsBanner: IAcademicsMppDetailsBannerData[];
}) => {
  useTabs();

  return (
    <section>
      <div className="td_height_50 td_height_lg_40" />

      <div className="container">
        <div className="row td_gap_y_24">
          <div key={academicsMppDetailsBanner[0]?.id}>
            <div className="td_card td_style_5 ">
              <div className="td_card_thumb">
                <span className="td_card_thumb_in td_radius_10">
                  <img
                    src={`${process.env.REACT_APP_cmsUrl}/uploads/${academicsMppDetailsBanner[0]?.image[0]?.media?.name}`}
                    alt={academicsMppDetailsBanner[0]?.title}
                  />
                </span>
              </div>
              <div className="td_card_content">
                {/* <ul className="td_card_meta td_mp_0 td_fs_16 td_heading_color">
                      <li>
                        <img src={user} alt="User icon" />
                        <span className="td_opacity_7">
                          {academicsMppDetailsBanner[0]?.seats} Seats
                        </span>
                      </li>
                      <li>
                        <img src={book} alt="Book icon" />
                        <span className="td_opacity_7">
                          {academicsMppDetailsBanner[0]?.years} Years
                        </span>
                      </li>
                    </ul> */}
                <h2 className="td_card_title td_fs_24 td_semibold td_mb_12">
                  <div>{academicsMppDetailsBanner[0]?.title}</div>
                </h2>

                <p
                  className="td_section_subtitle td_fs_18 mb-12"
                  dangerouslySetInnerHTML={{
                    __html: academicsMppDetailsBanner[0]?.description,
                  }}
                />

                <div className="td_card_btns_wrap">
                  <Link
                    // to="/application-form"
                    to="#"
                    className="td_btn td_style_1 td_radius_10 td_medium"
                    onClick={(e) => e.preventDefault()}
                    style={{ cursor: "not-allowed" }}
                  >
                    <span className="td_btn_in td_white_color td_orange_bg disabled_btn">
                      <span>Apply Now</span>
                      <svg
                        width="19"
                        height="20"
                        viewBox="0 0 19 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.1575 4.34302L3.84375 15.6567"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M15.157 11.4142C15.157 11.4142 16.0887 5.2748 15.157 4.34311C14.2253 3.41142 8.08594 4.34314 8.08594 4.34314"
                          stroke="currentColor"
                          strokeWidth="1.5"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </Link>
                  {/* <Link
                        to="/application-form"
                        className="td_btn td_style_1 td_type_3 td_radius_10 td_medium td_fs_14"
                        onClick={(e) => e.preventDefault()}
                        style={{ cursor: "not-allowed" }}
                      >
                        <span className="td_btn_in td_white_color give_btn disabled_btn">
                          <span>Apply Now</span>
                        </span>
                      </Link> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="td_height_50 td_height_lg_50" />
    </section>
  );
};

export default GraduateIntroBanner;
